import Photo from "../ui/Photo";
import { ARTICLES } from "../../data/salon";
import { toFa } from "../../lib/format";
import { useStagger } from "../../lib/motion";
import { SectionHead } from "../ui/Bits";

export default function Journal() {
  const grid = useStagger({ step: 100 });

  return (
    <section className="section section--defer journal">
      <div className="wrap wrap--wide">
        <SectionHead
          eyebrow="THE JOURNAL"
          title="چیزهایی که <em>خوب است</em> بدانی"
          lede="نوشته‌های کوتاه از متخصص‌های خودمان، بدون تبلیغ."
        />

        <div className="journal__grid" ref={grid}>
          {ARTICLES.map((a) => (
            <article key={a.slug} className="jart reveal" data-stagger="">
              <Photo src={a.photo} ratio="4 / 3" className="jart__cover ph--hover" tint="soft" />
              <span className="eyebrow eyebrow--violet">{a.latin}</span>
              <h3>{a.title}</h3>
              <p>{a.excerpt}</p>
              <span className="jart__read">{toFa(a.read)} دقیقه مطالعه</span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
